import React from 'react';

/**
 * Anchor renderer for Markdown links, so following one never navigates the
 * board, task, or chat panel the reader is in away from under them.
 *
 * Fragment links (`#section`) are the exception: those scroll within the
 * document already rendered, and opening a second tab would reload the page
 * instead of moving to the heading.
 *
 * `rel` is set explicitly rather than left to the browser's implicit
 * `noopener` — some Markdown here is written by other users (message board
 * posts, bot answers), so the opened page gets no `window.opener` handle and
 * no referrer.
 *
 * Lives apart from `index.tsx` so it can be unit tested: that module imports
 * react-markdown, which is ESM and unavailable under this Jest config.
 */
export function MarkdownLink({ href, title, children }: React.ComponentPropsWithoutRef<'a'>) {
  if (href?.startsWith('#')) {
    return (
      <a href={href} title={title}>
        {children}
      </a>
    );
  }
  return (
    <a href={href} title={title} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  );
}
